import { Component, OnInit, OnDestroy, ViewChild, ElementRef, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SelectionModel } from "@angular/cdk/collections";
import { MatPaginator, MatSort } from "@angular/material";
import { debounceTime, distinctUntilChanged, tap, skip } from "rxjs/operators";
import { fromEvent, merge, Subscription } from "rxjs";
import { Store } from "@ngrx/store";
import { AppState } from "../../../../../core/reducers";
import { LayoutUtilsService, MessageType, QueryParamsModel } from "../../../../../core/_base/crud";
import { WaterTransactionDataSource } from "../../../../../core/water/transaction/transcation.datasource";
import { WaterTransactionModel } from "../../../../../core/water/transaction/transaction.model";
import { SubheaderService } from "../../../../../core/_base/layout";
import { WaterTransactionService } from "../../../../../core/water/transaction/transaction.service";
import { WaterTransactionDeleted, WaterTransactionPageRequested } from "../../../../../core/water/transaction/transaction.action";
import { QueryWaterTransactionModel } from "../../../../../core/water/transaction/querytransaction.model";
import { HttpClient } from "@angular/common/http";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormControl } from "@angular/forms";
import { MatDatepicker } from "@angular/material/datepicker";
import { default as _rollupMoment, Moment } from "moment";
import * as _moment from "moment";
import { ServiceMenus } from "../../../../../core/serviceMenu/serviceMenu";

const moment = _rollupMoment || _moment;

@Component({
	selector: "kt-list-transaction",
	templateUrl: "./list-transaction.component.html",
	styleUrls: ["./list-transaction.component.scss"],
})
export class ListTransactionComponent implements OnInit, OnDestroy {
	file;
	dataSource: WaterTransactionDataSource;
	displayedColumns = ["watname", "unit", "strtpos", "endpos", "cons", "billmonth", "status", "actions"];
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild("sort1", { static: true }) sort: MatSort;
	@ViewChild("searchInput", { static: true }) searchInput: ElementRef;
	lastQuery: QueryParamsModel;
	data = localStorage.getItem("currentUser");
	dataUser = JSON.parse(this.data);
	role = this.dataUser.role;
	selection = new SelectionModel<WaterTransactionModel>(true, []);
	waterTransactionResult: WaterTransactionModel[] = [];
	private subscriptions: Subscription[] = [];
	qParams_storage = JSON.parse(sessionStorage.getItem("trwater_filter"));

	date = {
		valid: false,
		filter: {
			control: new FormControl(),
			val: undefined,
		},
		start: {
			control: new FormControl(),
			val: undefined,
		},
		end: {
			control: new FormControl(),
			val: undefined,
		},
	};

	datePicker: Date = new Date();
	dateConfirm: Date = new Date(this.datePicker.getFullYear(), this.datePicker.getMonth(), this.datePicker.getDate());

	dateMonth = new FormControl();

	valPayDate: string;
	checkClearDate: boolean;
	checkClear: boolean;

	// Navigate Route
	navMatTab: any[] = [
		{ name: "All Water Consumption", value: "all", tab: true },
		{ name: "New Water Consumption", value: "new", tab: false },
	];

	selectedPhoto: string | null = null;
	selectedUnitInfo: any = null;

	constructor(private activatedRoute: ActivatedRoute, private store: Store<AppState>, private router: Router, private service: WaterTransactionService, private layoutUtilsService: LayoutUtilsService, private subheaderService: SubheaderService, private cdr: ChangeDetectorRef, private http: HttpClient, private modalService: NgbModal, private serviceMenus: ServiceMenus) {}

	ngOnInit() {
		if (this.qParams_storage) {
			// Initialize filters from storage
			if (this.qParams_storage.filter) {
				if (this.qParams_storage.filter.unit) {
					this.searchInput.nativeElement.value = this.qParams_storage.filter.unit;
					this.checkClear = true;

				}
			}
			if (this.qParams_storage.date) {
				this.valPayDate = this.qParams_storage.date;
				this.dateMonth.setValue(moment(this.valPayDate, "MM/YYYY"));
				this.checkClear = true;
			}

			// Initialize pagination and sorting
			if (this.qParams_storage.page !== undefined) {
				this.paginator.pageIndex = this.qParams_storage.page - 1;
			}
			if (this.qParams_storage.limit) {
				this.paginator.pageSize = this.qParams_storage.limit;
			}
			if (this.qParams_storage.sortField) {
				this.sort.active = this.qParams_storage.sortField;
			}
			if (this.qParams_storage.sortOrder) {
				this.sort.direction = this.qParams_storage.sortOrder;
			}
		}
		const sortSubscription = this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
		this.subscriptions.push(sortSubscription);
		this.serviceMenus.loadFeatureAccess("/water-management/water/transaction").subscribe();
		const paginatorSubscriptions = merge(this.sort.sortChange, this.paginator.page, fromEvent(this.searchInput.nativeElement, "keyup"))
			.pipe(
				debounceTime(150),
				distinctUntilChanged(),
				tap(() => {
					this.loadWaterTransactionList();
				})
			)
			.subscribe();
		this.subscriptions.push(paginatorSubscriptions);
		const searchSubscription = fromEvent(this.searchInput.nativeElement, "keyup")
			.pipe(
				debounceTime(150),
				tap(() => {
					this.checkClear = true;
					this.paginator.pageIndex = 0;
					this.loadWaterTransactionList();
				})
			)
			.subscribe();
		this.subscriptions.push(searchSubscription);

		this.subheaderService.setTitle("Water Consumption");

		this.dataSource = new WaterTransactionDataSource(this.store);
		const entitiesSubscription = this.dataSource.entitySubject.pipe(skip(1), distinctUntilChanged()).subscribe((res) => {
			this.waterTransactionResult = res;
		});
		this.subscriptions.push(entitiesSubscription);
		this.loadWaterTransactionList();

	}
	filterConfiguration(): any {
		const filter: any = {};
		const searchText: string = this.searchInput.nativeElement.value.toLowerCase();
		filter.unit = `${searchText}`;
		return filter;
	}
	loadWaterTransactionList() {
		this.selection.clear();
		const queryParams = new QueryWaterTransactionModel(
			// this.searchInput.nativeElement.value,
			this.filterConfiguration(),
			this.date.valid ? this.date.start.val : 0,
			this.date.valid ? this.date.end.val : 0,
			this.valPayDate,
			this.sort.direction ? this.sort.direction : "desc",
			this.sort.active ? this.sort.active : "billmnt",
			this.paginator.pageIndex + 1,
			this.paginator.pageSize
		);

		let qParams_to_sessionStorage = { ...queryParams };
		sessionStorage.setItem("trwater_filter", JSON.stringify(qParams_to_sessionStorage));

		this.store.dispatch(new WaterTransactionPageRequested({ page: queryParams }));
		this.selection.clear();
	}

	deleteWaterTransaction(_item: WaterTransactionModel) {
		const _title = "Water Consumption Delete";
		const _description = "Are you sure to permanently delete this water consumption?";
		const _waitDesciption = "Water consumption is deleting...";
		const _deleteMessage = `Water consumption has been deleted`;
		const _errMessage = `Error | Billing Consumption Exist`;

		const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption);
		dialogRef.afterClosed().subscribe((res) => {
			if (!res) {
				return;
			} else {
				this.service.deleteWaterTransaction(_item._id).subscribe(
					(res) => {
						this.layoutUtilsService.showActionNotification(_deleteMessage, MessageType.Delete);
						this.ngOnInit();
					},
					(err) => {
						this.layoutUtilsService.showActionNotification(_errMessage, MessageType.Delete);
						this.ngOnInit();
					}
				);
			}

			// this.store.dispatch(new WaterTransactionDeleted({ id: _item._id }));

			// this.layoutUtilsService.showActionNotification(_deleteMessage, MessageType.Delete);
		});
	}
	fetchPowerTransaction() {
		const messages = [];
		this.selection.selected.forEach((elem) => {
			messages.push({
				text: `${elem.wat.nmmtr} , Rate: Rp. ${elem.wat.rte.rte}, Unit: ${elem.wat.unt.nmunt}`,
				id: elem._id.toString(),
				status: elem.wat.nmmtr,
			});
		});
		this.layoutUtilsService.fetchElements(messages);
	}
	isAllSelected(): boolean {
		const numSelected = this.selection.selected.length;
		const numRows = this.waterTransactionResult.length;
		return numSelected === numRows;
	}
	masterToggle() {
		if (this.selection.selected.length === this.waterTransactionResult.length) {
			this.selection.clear();
		} else {
			this.waterTransactionResult.forEach((row) => this.selection.select(row));
		}
	}
	editWaterTransaction(id) {
		this.router.navigate(["edit", id], { relativeTo: this.activatedRoute });
	}
	viewWaterTransaction(id) {
		this.router.navigate(["view", id], { relativeTo: this.activatedRoute });
	}

	// Fungsi untuk kondisi strtpos2 tidak ada dan endpos2 tidak ada #START
	convertStrtpos(value) {
		// START POS
		const strtpos = value;
		return strtpos;
	}
	convertEndpos(value) {
		// END POS
		const endpos = value;
		return endpos;
	}

	// For Consumption START
	checkConsumptionNotStrtEnd2(strt, end) {
		const strtpos = strt;
		const strtposResult = strtpos;
		const resultStrt = strtposResult;

		const endpos = end;
		const endposResult = endpos;
		const resultEnd = endposResult;

		const data = resultEnd - resultStrt;
		const result = data;

		return result;
	}
	// For Consumption END
	// Fungsi untuk kondisi strtpos2 tidak ada dan endpos2 tidak ada #END

	// Refresh Start
	refresh() {
		this.loadWaterTransactionList();
	}
	// Refresh End

	checkConsumption(strt, end) {
		// fungsi untuk menentukan nilai consumption (last meter dikurangi Start Meter)
		const start2 = strt;
		const end2 = end;

		const data = end2 - start2;
		const result = data;

		return result;
	}

	matTabSelection(status) {
		if (status === "all") this.router.navigateByUrl("/water-management/water/transaction", { relativeTo: this.activatedRoute });
		else if (status === "new") this.router.navigateByUrl("/water-management/water/transaction/new", { relativeTo: this.activatedRoute });
	}

	openLarge(content) {
		this.modalService.open(content, {
			size: "lg",
			backdrop: "static",
		});
	}
	addDate(type, e) {
		if (type === "end") {
			let tempDate = moment(e.target.value).add(1, "day");
			this.date[type].val = tempDate;
		} else {
			this.date[type].val = e.target.value;
		}
		this.checkDateValidation();

		// Fetch list if date is filled
		if (this.date.valid) {
			this.loadWaterTransactionList();
		}
	}
	checkDateValidation() {
		if (this.date.start.val && this.date.end.val) {
			if (this.date.start.val > this.date.end.val) {
				this.date.valid = false;
				const message = `End Date should be greater than Start Date`;
				this.layoutUtilsService.showActionNotification(message, MessageType.Create, 5000, true, true);
			} else {
				this.date.valid = true;
			}
		} else {
			this.date.valid = false;
		}
	}

	clearAllFilter() {
		this.date.valid = false;
		this.searchInput.nativeElement.value = "";
		this.date.start.val = undefined;
		this.date.start.control.setValue(undefined);
		this.date.end.val = undefined;
		this.date.end.control.setValue(undefined);
		this.date.filter.control.setValue(undefined);

		this.dateMonth.setValue(undefined);

		this.valPayDate = undefined;
		this.date.filter.control.setValue(undefined);
		this.checkClear = false;

		this.loadWaterTransactionList();
	}

	export() {
		const queryParams = new QueryWaterTransactionModel(this.searchInput.nativeElement.value, this.date.valid ? this.date.start.val : 0, this.date.valid ? this.date.end.val : 0, this.valPayDate, this.sort.direction ? this.sort.direction : "desc", this.sort.active ? this.sort.active : "billmnt", this.paginator.pageIndex + 1, this.paginator.pageSize);
		this.service.exportExcel(queryParams);
		this.clearAllFilter();
	}

	ngOnDestroy() {
		this.subscriptions.forEach((sb) => sb.unsubscribe());
	}

	setMonthAndYear(normalizedMonthAndYear, datepicker: MatDatepicker<Moment>) {
		let ctrlValue = this.dateMonth.value;
		console.log(normalizedMonthAndYear, "normalizedMonthAndYear");

		// ctrlValue.month(normalizedMonthAndYear.month());
		// ctrlValue.year(normalizedMonthAndYear.year());

		this.dateMonth.setValue(normalizedMonthAndYear);

		datepicker.close();
		let datVal = moment(this.dateMonth.value).format("L").split("/");
		let result = `${datVal[0]}/${datVal[2]}`;
		this.valPayDate = result;

		this.checkClearDate = true;
		if (this.checkClearDate) this.checkClear = true;

		// this.loadBillingList(this.valPayCond, result)
		this.loadWaterTransactionList();
	}

	/**
	 * changeMeteran
	 * @param value
	 * @returns
	 */
	changeMeteran(value: any) {
		console.log(value, "valuenya");
		if (value === null || value === undefined) return "-";
		const strValue = String(value);
		return strValue.replace(".", ",");
	}

	openNgbPhotoModal(content: any, consumption: any) {
		if (consumption.attachment && consumption.attachment.length) {
			this.selectedPhoto = `http://108.136.183.186:3451/transWaterImage/${consumption.attachment[0]}`;
		} else if (consumption.urlmeter) {
			this.selectedPhoto = consumption.urlmeter;
		} else {
			this.selectedPhoto = null;
		}

		this.selectedUnitInfo = consumption || null;
		this.modalService.open(content, { size: "lg", centered: true });
	}
}
